import { Inject, Injectable, inject, isDevMode } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { CookieService } from 'ngx-cookie-service';
import Smartlook from 'smartlook-client';

import { MonitoringService } from './monitoring.service';
import { EnvironmentConfig } from '../config/environment.config';

const Accepted = 'ACCEPTED';

@Injectable({ providedIn: 'root' })
export class CookiesService {
  cookieService = inject(CookieService);

  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private monitoringService: MonitoringService,
    private translateService: TranslateService,
    private toastController: ToastController
  ) {}

  async initCookies(): Promise<void> {
    const cookiesAccepted: boolean = this.cookieService.get('COOKIES_ACCEPTED') === Accepted;
    const allCokiesAccepted: boolean = this.cookieService.get('All_COOKIES_ACCEPTED') === Accepted;

    if (!cookiesAccepted && !allCokiesAccepted) {
      this.handleCookieBanner();
    } else if (allCokiesAccepted) {
      this.setCookies();
    }
  }

  private async setCookies(): Promise<void> {
    if (isDevMode()) {
      return;
    }

    Smartlook.init(this.environment.smartlookKey);
    this.monitoringService.init();
  }

  private async handleCookieBanner(): Promise<void> {
    const toast = await this.toastController.create({
      message: this.translateService.instant('COOKIES'),
      position: 'bottom',
      cssClass: 'banner-toast',
      buttons: [
        {
          text: 'Learn more',
          role: 'learn-more',
          handler: (): boolean => {
            window.open('cookie-policy', '_blank');
            return false;
          }
        },
        {
          text: 'Accept Essentials',
          role: 'accept-essentials',
          handler: (): void => {
            this.cookieService.set('COOKIES_ACCEPTED', Accepted);
          }
        },
        {
          text: 'Accept All',
          role: 'cancel',
          handler: (): void => {
            this.setCookies();
            this.cookieService.set('All_COOKIES_ACCEPTED', Accepted);
          }
        }
      ]
    });

    toast.present().then(() => {
      const toasts = document.getElementsByClassName('banner-toast');
      const shadow = toasts[0].shadowRoot;
      const childNodes = Array.from(shadow.childNodes);
      childNodes.forEach((childNode: any) => {
        const buttonsGroup = childNode.getElementsByClassName('toast-button-group');
        buttonsGroup[0].setAttribute('style', 'flex-direction: row!important; gap: 8px;padding:8px;');
        const essentialButton = childNode.getElementsByClassName('toast-button-accept-essentials');
        essentialButton[0].setAttribute('style', 'border: 1px solid var(--ion-color-secondary); background: var(--ion-color-secondary) !important');
        const allButton = childNode.getElementsByClassName('toast-button-cancel');
        allButton[0].setAttribute('style', 'border: 1px solid var(--ion-color-secondary); background: var(--ion-color-secondary) !important');
        const secondButton = childNode.getElementsByClassName('toast-button-learn-more');
        secondButton[0].setAttribute('style', 'border: 0 !important;text-decoration: underline;');
      });
    });
  }
}
